import React from 'react';

export const ABOUT_HEADING = 'About EquipLinc Auction Group';

const AboutIntro = () => (
  <>
    <p>
      <strong>EquipLinc Auction Group</strong> is a full-service heavy truck
      and equipment auction company specializing in the nationwide remarketing
      of commercial assets to buyers around the world.
    </p>
    <p>
      Backed by more than{' '}
      <strong>85 years of combined industry experience</strong>, our team
      delivers the knowledge, market reach, and professional service needed to
      maximize exposure and results for every asset we represent.
    </p>
    <p>
      From heavy trucks and trailers to construction equipment and specialized
      commercial assets,{' '}
      <strong>
        EquipLinc Auction Group connects sellers with a global marketplace of
        qualified buyers.
      </strong>
    </p>
    <p>
      <strong>Experience. Exposure. Results. &mdash; EquipLinc Auction Group.</strong>
    </p>
  </>
);

export default AboutIntro;
